// extracted by mini-css-extract-plugin
export default {"wrapperLoader":"Loader_wrapperLoader__p1WDc","buttonLoader":"Loader_buttonLoader__f9sSI","spin":"Loader_spin__upHXa","spinner":"Loader_spinner__QiFfK"};